import React, { useState, useEffect, useContext } from "react";
import { Tooltip } from "antd";
import styled from "styled-components";
import { ReactComponent as SingleBedSvg } from "../../../assets/icons/single-bed.svg";
import { ReactComponent as DoubleBedSvg } from "../../../assets/icons/bed.svg";
import { ReactComponent as SofaSvg } from "../../../assets/icons/sofa.svg";
import { AppContext } from "../../../context";
import { openkit } from "../../../library/database";

const BedInfo = ({ beds }) => {
  const info = useContext(AppContext);
  const [bedCategories, setBedCategories] = useState([]);

  useEffect(() => {
    (async () => {
      const bedCategories = await openkit.data.find("bed_categories");
      setBedCategories(bedCategories);
    })();
  }, []);

  return Object.keys(beds).length > 0 ? (
    <div>
      {info.t("beds")}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "end",
        }}
      >
        {Object.keys(beds).map((b) => (
          <Tooltip title={info.t(b)}>
            {[...Array(beds[b])].map((_, index) => (
              <img
                className="icon-bed double"
                alt="icon"
                key={index}
                src={
                  bedCategories.find((cat) => cat.name === b)?.image?.[0]?.url
                }
                style={{
                  maxWidth: bedCategories.find((cat) => cat.name === b)
                    ?.max_width,
                  marginBottom: bedCategories.find((cat) => cat.name === b)
                    ?.margin,
                }}
              />
            ))}
          </Tooltip>
        ))}
      </div>
    </div>
  ) : (
    <div>&nbsp;</div>
  );
};

export default BedInfo;
